// src/components/staff/MyAccounts.jsx
import { useWmStaff } from '../../context/WmStaffContext';
import { useLocations, getDisplayName } from '../../context/LocationContext';

export default function MyAccounts({ onNavigate }) {
  const { wmStaffMember, enterOrgView } = useWmStaff();
  const { locations } = useLocations();

  const assignedIds = wmStaffMember?.assigned_location_ids ?? [];

  // Filter to assigned locations only; show all if no list set (senior/support shouldn't reach this)
  const assignedLocations = assignedIds.length > 0
    ? locations.filter(loc => assignedIds.includes(loc.id))
    : locations;

  const handleEnter = (loc) => {
    enterOrgView(loc.id, getDisplayName(loc));
    onNavigate('dashboard');
  };

  return (
    <div className="flex-1 overflow-auto p-6 max-w-2xl mx-auto w-full">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-2 h-2 rounded-full bg-emerald-400" style={{ boxShadow: '0 0 6px rgba(16,185,129,0.5)' }} />
          <span className="text-[var(--wm-text-caption)] font-bold uppercase tracking-widest text-emerald-400">WrapMind Staff</span>
        </div>
        <h1 className="text-[var(--wm-text-hero)] font-bold text-[#F8FAFE]">My Accounts</h1>
        <p className="text-[var(--wm-text-body)] text-[#7D93AE] mt-1">Your assigned shop locations.</p>
      </div>

      {assignedLocations.length === 0 && (
        <div className="rounded-xl border border-[#243348] bg-[#1B2A3E] px-6 py-10 text-center">
          <p className="text-[var(--wm-text-body)] text-[#7D93AE]">No locations assigned yet.</p>
          <p className="text-[var(--wm-text-ui)] text-[#4A6380] mt-1">Contact a Senior staff member to get locations assigned.</p>
        </div>
      )}

      {assignedLocations.length > 0 && (
        <div className="space-y-2">
          {assignedLocations.map(loc => (
            <div
              key={loc.id}
              className="flex items-center justify-between px-4 py-3 rounded-xl border border-[#243348] bg-[#1B2A3E] hover:border-emerald-400/30 transition-colors"
            >
              <div className="flex items-center gap-3 min-w-0">
                {loc.color && (
                  <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: loc.color }} />
                )}
                <div className="min-w-0">
                  <p className="text-[var(--wm-text-body)] font-semibold text-[#F8FAFE] truncate">{getDisplayName(loc)}</p>
                  {loc.address && (
                    <p className="text-[var(--wm-text-ui)] text-[#7D93AE] mt-0.5 truncate">{loc.address}{loc.city ? `, ${loc.city}` : ''}</p>
                  )}
                </div>
              </div>
              <button
                onClick={() => handleEnter(loc)}
                className="ml-4 px-4 py-1.5 text-[var(--wm-text-ui)] font-semibold rounded-lg bg-emerald-400/10 text-emerald-300 border border-emerald-400/25 hover:bg-emerald-400/20 transition-colors flex-shrink-0"
              >
                Enter
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
